module.exports = __webpack_public_path__ + "static/media/Icon_zoomOutExtents.a5b105fd.svg";